import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TAgreements, TTradeDetailsById } from "../types/trades/trades";
import moment from "moment";

type TInitialState = {
  tradeDetailsbyId: TTradeDetailsById | null;
  selectedDate: string;
  isSrcInvoiceUpdated: boolean;
  isDestInvoiceUpdated: boolean;
  isSrcPattiUpdated: boolean;
  isDestPattiUpdated: boolean;
  isPattiDocUpdated: boolean;
  isDispatchUpdated: boolean;
  isArrivalUpdated: boolean;
  isSrcPmtTerm: boolean;
  isDestPmtTerm: boolean;
  openDetailTabs: string;
  notificationTradeId: number;
  notificationTraderId: number;
  openCloseTrade: boolean;
  allAgreements: TAgreements[];
};

const initialState: TInitialState = {
  tradeDetailsbyId: null,
  selectedDate: moment().format("YYYY-MM-DD"),
  isSrcInvoiceUpdated: false,
  isDestInvoiceUpdated: false,
  isSrcPattiUpdated: false,
  isDestPattiUpdated: false,
  isPattiDocUpdated: false,
  isDispatchUpdated: false,
  isArrivalUpdated: false,
  isSrcPmtTerm: false,
  isDestPmtTerm: false,
  openDetailTabs: "Dispatch Details",
  notificationTradeId: 0,
  notificationTraderId: 0,
  openCloseTrade: false,
  allAgreements: [],
};

export const tradeDetailsByIdSlice = createSlice({
  name: "tradeDetails",
  initialState: initialState,
  reducers: {
    resetTradeDetails: (state) => {
      return {
        ...initialState,
      };
    },

    updateTradeDetailsById: (
      state,
      action: PayloadAction<{
        tradeDetailsbyId: TTradeDetailsById | null;
      }>
    ) => {
      state.tradeDetailsbyId = action.payload.tradeDetailsbyId;
    },

    setSelectedDate: (state, action) => {
      state.selectedDate = action.payload;
    },
    setSrcInvoiceUpdated: (state, action) => {
      state.isSrcInvoiceUpdated = action.payload;
    },
    setDestInvoiceUpdated: (state, action) => {
      state.isDestInvoiceUpdated = action.payload;
    },
    setOpenCloseTrade: (state, action) => {
      state.openCloseTrade = action.payload;
    },
    setSrcPattiUpdated: (state, action) => {
      state.isSrcPattiUpdated = action.payload;
    },
    setDestPattiUpdated: (state, action) => {
      state.isDestPattiUpdated = action.payload;
    },
    setPattiDocUpdated: (state, action) => {
      state.isPattiDocUpdated = action.payload;
    },
    setDispatchUpdated: (state, action) => {
      state.isDispatchUpdated = action.payload;
    },
    setArrivalUpdated: (state, action) => {
      state.isArrivalUpdated = action.payload;
    },
    setSrcPmtUpdated: (state, action) => {
      state.isSrcPmtTerm = action.payload;
    },
    setDestPmtUpdated: (state, action) => {
      state.isDestPmtTerm = action.payload;
    },
    setOpenDetailTabs: (state, action) => {
      state.openDetailTabs = action.payload;
    },

    updateNotifiTradeId: (
      state,
      action: PayloadAction<{
        notificationTradeId: number;
      }>
    ) => {
      state.notificationTradeId = action.payload.notificationTradeId;
    },

    updateNotifiTraderId: (
      state,
      action: PayloadAction<{
        notificationTraderId: number;
      }>
    ) => {
      state.notificationTraderId = action.payload.notificationTraderId;
    },
    setAgreements: (state, action) => {
      state.allAgreements = action.payload;
    },
  },
});

export const {
  updateTradeDetailsById,
  setSelectedDate,
  setSrcInvoiceUpdated,
  setDestInvoiceUpdated,
  setSrcPattiUpdated,
  setDestPattiUpdated,
  setDispatchUpdated,
  setArrivalUpdated,
  setSrcPmtUpdated,
  setDestPmtUpdated,
  setOpenDetailTabs,
  updateNotifiTradeId,
  updateNotifiTraderId,
  setPattiDocUpdated,
  setOpenCloseTrade,
  setAgreements,
} = tradeDetailsByIdSlice.actions;
export default tradeDetailsByIdSlice.reducer;
